import { render, staticRenderFns } from "./DepartmentDialog.vue?vue&type=template&id=5afeadca&scoped=true"
import script from "./DepartmentDialog.vue?vue&type=script&lang=js"
export * from "./DepartmentDialog.vue?vue&type=script&lang=js"
import style0 from "./DepartmentDialog.vue?vue&type=style&index=0&id=5afeadca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afeadca",
  null
  
)

export default component.exports